import {ClientDevice} from 'interfaces';

export const WHITE_LABEL_PREVIEW_SESSION_PARAMS = {
    token: 'XXXX-XXXX-XXXX-XXXX',
    client: {
        data: {
            clientInfo: {
                browser: 'Chrome',
                browserVersion: '104.0.0.0',
                os: 'OS X',
                osVersion: '10.15.7'
            },
            device: ClientDevice.Browser,
            location: null
        },
        userInfo: {
            id: '2',
            firstName: 'John',
            lastName: 'Smith',
            controlOnlyInfo: {}
        },
        id: '2'
    },
    id: 'Session_Id_1',
    version: 1
};
